import styled from 'styled-components';

export const FormBodyWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 0 6rem;
  margin-bottom: 4.6rem;
`;
